import { render, staticRenderFns } from "./ReferenceValuesTableModal.vue?vue&type=template&id=9a916264&scoped=true"
import script from "./ReferenceValuesTableModal.vue?vue&type=script&lang=js"
export * from "./ReferenceValuesTableModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceValuesTableModal.vue?vue&type=style&index=0&id=9a916264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a916264",
  null
  
)

export default component.exports